<template>
<main class="single-biogram">
            <div class="col-2">
                <h1>Etykiety</h1>
                <div class="text-up">
                    <p class="biogram-text tags">
                      <span v-for="(t,i) in this.$parent.tags" :key="i">
                        <router-link :title="'Wszystkie obiekty oznaczone etykietą ' + t.name" :to="'/etykieta/' + t.name">{{t.name}}</router-link>
                      </span>
                    </p>
                    <div class="icon-links to-center">
                    </div>
                </div>
            </div>
        </main>
</template>

<script>
// components

import BiogramRelated from "@/components/Biogram/BiogramRelated.vue";

// functions

export default {
  name: "AllTagsContent",
  components: {
  },
  data() {
    return {
      msg: "Welcome to Your Vue.js App",
         };
  }
};
</script>

<style scoped>

.col-2>div {
  width: 100%;
}

.tags span {
  font-size: 0.5em;
  display: inline-block;
  padding: 5px;
  background: #465165;
  margin: 5px;
  text-transform: uppercase;
}

.tags span a {
  color: #fff;
}

.tags span a:hover {
  color: #c63;
}
</style>


// WEBPACK FOOTER //
// src/components/AllTags/AllTagsContent.vue